import React from 'react';
import { Head } from '@src/components/elements';
const Magazine = ({ children }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Head, { id: "magazine", imageUrl: "/media/images/meta-magazine.png" }),
        children));
};
export default Magazine;
